<template>
  <div class="header" :class="cls">
    <div class="pull-left">
      <span v-if="enableBack" class="icon-back" @click="prevPage" />
      <span v-if="enableClose" class="icon-close" @click="colseFunc" />
    </div>
    <slot name="title"></slot>
    <span class="pull-right">
      <gm-share v-if="enableShare" :message="shareMessage" />
      <slot />
    </span>
  </div>
</template>

<script>
import qs from 'qs'
import native from '@/utils'
import GmShare from '../Share'
import { getUserAgent } from '../../utils/nativeInfo'
import './header.scss'

const { NativeFuncs, callNativeAsyncFunc } = native
export default {
  props: {
    size: {
      // 组件大小
      type: String,
      default: '',
    },
    enableClose: {
      // 是否可以关闭
      type: Boolean,
      default: true,
    },
    enableBack: {
      // 是否可以回退
      type: Boolean,
      default: false,
    },
    enableShare: {
      // 是否可以分享
      type: Boolean,
      default: false,
    },
    jumpUrl: {
      // 点关闭跳转链接，默认主页
      type: String || Function,
      default: '/',
    },
    theme: {
      // 主题颜色
      type: String,
      default: 'light',
    },
    shareMessage: {
      // 分享内容
      type: Object,
    },
  },
  components: {
    GmShare,
  },
  data() {
    return {
      cls: '',
    }
  },
  mounted() {
    const search = window.location.search.slice(1)
    const theme = qs.parse(search).theme || this.theme
    const bool = theme === 'light' || theme === 'dark'
    this.cls = `${bool ? theme : 'light'} ${this.size}`
    if (getUserAgent().service === 'IOS') {
      callNativeAsyncFunc(
        NativeFuncs.SYSTEM.STATUS_BAR_STYLE,
        {
          style: theme === 'light' ? 'black' : 'white',
          color: theme === 'light' ? '#000000' : '#ffffff',
          bgColor: theme === 'light' ? '#ffffff' : '#000000',
        },
        true
      )
    }
  },
  methods: {
    // 后退
    prevPage() {
      this.$router.back()
    },
    // 关闭
    colseFunc() {
      if (typeof this.jumpUrl === 'string') {
        this.$router.push(this.jumpUrl)
      } else {
        this.jumpUrl()
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/GlobalHeader/Header.vue